/* src/components/pages/Home.jsx */
/* ----------------------------- */

import React, { useEffect } from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { RiVideoFill } from 'react-icons/ri';

const Home = ({ onMenuSelect }) => {
  /* 🔒 Bloquear retroceso */
  useEffect(() => {
    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
    };
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const handleMenuClick = (menu) => {
    onMenuSelect?.(menu);
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'url(/fondo_home.png)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        px: 3,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          color: '#5d6d7e',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          mb: 2,
        }}
      >
        Bienvenido a
        <RiVideoFill size={40} style={{ color: '#F5A53D' }} />
        Overwatch
      </Typography>

      <Typography variant="h5" sx={{ color: '#5d6d7e', mb: 6 }}>
        Desde aquí podrás gestionar todos los aspectos de la plataforma.
      </Typography>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={3}
        sx={{ width: '100%', maxWidth: 900 }}
      >
        <Button fullWidth variant="contained" onClick={() => handleMenuClick('CLIENTES')}>
          Clientes
        </Button>
        <Button fullWidth variant="contained" sx={{ backgroundColor: '#BD982D' }}
          onClick={() => handleMenuClick('ENROLADOS')}>
          Enrolados
        </Button>
        <Button fullWidth variant="contained" color="success"
          onClick={() => handleMenuClick('CESIONES')}>
          Cesiones
        </Button>
        <Button fullWidth variant="contained" color="secondary"
          onClick={() => handleMenuClick('RECURSOS')}>
          Recursos
        </Button>
        <Button fullWidth variant="contained" sx={{ backgroundColor: '#ca531f' }}
          onClick={() => handleMenuClick('PROVEEDORES')}>
          Proveedores
        </Button>
      </Stack>
    </Box>
  );
};

export default Home;




// /* src/components/pages/Home.jsx - Última MOdificación: 26-12-2025 */
// /* --------------------------------------------------------------- */

// import React, { useEffect, useCallback } from 'react';
// import Swal from 'sweetalert2';
// import 'sweetalert2/dist/sweetalert2.css';
// import { jwtDecode } from 'jwt-decode';
// import { Box, Typography, Button, Stack } from '@mui/material';
// import { RiVideoFill } from 'react-icons/ri';

// const Home = ({ onMenuSelect }) => {
//   /* 🔒 Bloquear retroceso */
//   useEffect(() => {
//     const handlePopState = () => {
//       window.history.pushState(null, '', window.location.href);
//     };
//     window.history.pushState(null, '', window.location.href);
//     window.addEventListener('popstate', handlePopState);
//     return () => window.removeEventListener('popstate', handlePopState);
//   }, []);

//   /* 🔐 Token */
//   const isTokenValid = token => {
//     try {
//       const decoded = jwtDecode(token);
//       return decoded.exp >= Date.now() / 1000;
//     } catch {
//       return false;
//     }
//   };

//   const handleTokenExpiration = useCallback(() => {
//     Swal.fire({
//       icon: 'info',
//       title: 'Aviso',
//       text: 'La Sesión ha Finalizada',
//       footer: '▶️ Overwatch',
//       allowOutsideClick: false,  // 👈 evita cierre con click afuera
//       background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
//       color: '#f8fafc',
//       showConfirmButton: false,
//       timer: 1800,
//       customClass: {
//         popup: 'swal-custom-popup',
//         title: 'swal-custom-title',
//         htmlContainer: 'swal-custom-text'
//       }
//     });
//     sessionStorage.removeItem('authToken');
//     setTimeout(() => (window.location.href = '/login'), 1600);
//   }, []);

//   useEffect(() => {
//     const token = sessionStorage.getItem('authToken');
//     if (!token || !isTokenValid(token)) {
//       handleTokenExpiration();
//     }
//   }, [handleTokenExpiration]);

//   const handleMenuClick = (menu) => {
//     onMenuSelect?.(menu);
//   };

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         height: '100%',
//         minHeight: '100%',

//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',

//         backgroundImage: 'url(/fondo_home.png)',
//         backgroundRepeat: 'no-repeat',
//         backgroundPosition: 'center',
//         backgroundSize: 'cover',

//         px: 3,
//       }}
//     >
//       <Typography
//         variant="h3"
//         sx={{
//           color: '#5d6d7e',
//           display: 'flex',
//           alignItems: 'center',
//           gap: 1,
//           mb: 2,
//         }}
//       >
//         Bienvenido a
//         <RiVideoFill size={40} style={{ color: '#F5A53D' }} />
//         OverWatch
//       </Typography>

//       <Typography variant="h5" sx={{ color: '#5d6d7e', mb: 6 }}>
//         Desde aquí podrás gestionar todos los aspectos de la plataforma.
//       </Typography>

//       <Stack
//         direction={{ xs: 'column', sm: 'row' }}
//         spacing={3}
//         sx={{ width: '100%', maxWidth: 900 }}
//       >
//         <Button fullWidth variant="contained" onClick={() => handleMenuClick('CLIENTES')}>
//           Clientes
//         </Button>
//         <Button fullWidth variant="contained" sx={{ backgroundColor: '#BD982D' }}
//           onClick={() => handleMenuClick('ENROLADOS')}>
//           Enrolados
//         </Button>
//         <Button fullWidth variant="contained" color="success"
//           onClick={() => handleMenuClick('CESIONES')}>
//           Cesiones
//         </Button>
//         <Button fullWidth variant="contained" color="secondary"
//           onClick={() => handleMenuClick('RECURSOS')}>
//           Recursos
//         </Button>
//         <Button fullWidth variant="contained" sx={{ backgroundColor: '#ca531f' }}
//           onClick={() => handleMenuClick('PROVEEDORES')}>
//           Proveedores
//         </Button>
//       </Stack>
//     </Box>
//   );
// };

// export default Home;
